import {useEffect} from 'react'

import {
    publish,
    publishAsync,
    subscribe,
    subscribeOnce,
    unsubscribe,
} from '@/script/event.mjs'

export const eventBus = {
    publish(...args) {publish(this, ...args)},
    async publishAsync(...args) {await publishAsync(this, ...args)},
    subscribe(...args) {subscribe(this, ...args)},
    subscribeOnce(...args) {subscribeOnce(this, ...args)},
    unsubscribe(...args) {unsubscribe(this, ...args)},
}

export const useEventBus = (eventType, callback) => {
    useEffect(
        () => {
            eventBus.subscribe(eventType, callback)
            return () => eventBus.unsubscribe(eventType, callback)
        },

        [eventType, callback]
    )
}
